import React, { useCallback } from 'react';
import styled from 'styled-components';
import SimpleBar from 'simplebar-react';
import { useDispatch, useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Popover from '../../../Popover';
import Confirm from '../../../Confirm';
import { Body } from './AddSectionModal.stc';
import * as actions from '../../../../redux/actions';
import { getIsAdmin } from '../../../../redux/selectors';
import graphFetch from '../../../../util/graphFetch';

const Section = styled(Body)`
    gap: 20px;
    column-count: ${({ colSize }) => colSize};
`;
const Img = styled.img`
    width: 100%;
    display: block;
    border-radius: 5px;
`;

const Zoom = styled.div`
    width: 350px;
`;

const ItemWrap = styled.div`
    padding-bottom: 20px;
`;

const Item = styled.div`
    cursor: pointer;
    position: relative;
    border-radius: 5px;
    border: 1px solid #e5ebf0;
`;

const RemoveWrap = styled.div`
    top: 10px;
    z-index: 2;
    right: 10px;
    position: absolute;
`;

const Remove = styled.span`
    width: 30px;
    height: 30px;
    font-size: 14px;
    background: #fff;
    border-radius: 5px;
    align-items: center;
    display: inline-flex;
    justify-content: center;

    svg {
        color: var(--color-danger-500);
    }
`;

const Desc = styled.div`
    top: 0;
    left: 0;
    color: #fff;
    width: 100%;
    height: 100%;
    position: absolute;
    border-radius: 5px;
    background-image: linear-gradient(
        to bottom,
        transparent,
        rgba(0, 0, 0, 0.8)
    );
`;

const Text = styled.p`
    bottom: 0;
    color: #ffffff;
    margin: 20px;
    position: absolute;
`;

function Element({ element, isProvided, addElement, isAdmin }) {
    const dispatch = useDispatch();
    const isRemoveVisible = isAdmin || !isProvided;
    const removeElement = useCallback(() => {
        dispatch(actions.removeElement(element.id));
    }, [dispatch, element.id]);

    const handleAddElement = useCallback(() => {
        (async function () {
            const { data } = await graphFetch({
                queryName: 'element',
                args: { id: { type: 'ID!', value: element.id } },
                select: 'data',
            });
            const elData = data?.element?.data;
            if (elData) {
                addElement({ data: JSON.parse(elData), elType: element.type });
            }
        })();
    }, [addElement, element]);

    return (
        // <Popover
        //     key={element.id}
        //     placement="top"
        //     trigger="hover"
        //     content={
        //         <Zoom>
        //             <Img src="http://source.unsplash.com/250x150" alt="" />
        //         </Zoom>
        //     }
        // >
        <ItemWrap>
            <Item>
                {isRemoveVisible && (
                    <RemoveWrap>
                        <Confirm
                            text="Are you sure to delete?"
                            onConfirm={removeElement}
                        >
                            <Remove>
                                <FontAwesomeIcon
                                    fixedWidth
                                    icon={['far', 'trash-alt']}
                                />
                            </Remove>
                        </Confirm>
                    </RemoveWrap>
                )}
                <div title="Click to Add" onClick={handleAddElement}>
                    <Img
                        src={
                            element.thumbnail ||
                            '/assets/images/image-placeholder.jpg'
                        }
                        alt=""
                    />
                    {!isProvided && (
                        <Desc>
                            <Text>{element.title}</Text>
                        </Desc>
                    )}
                </div>
            </Item>
        </ItemWrap>
        // </Popover>
    );
}

function LibraryView({ data = [], ...restOfProps }) {
    const { isProvided } = restOfProps;
    const colSize = isProvided ? 2 : 3;
    const isAdmin = useSelector(getIsAdmin);

    return (
        <Section colSize={colSize}>
            {data.map((item) => (
                <Element
                    key={item.id}
                    element={item}
                    isAdmin={isAdmin}
                    {...restOfProps}
                />
            ))}
        </Section>
    );
}

export default React.memo(LibraryView);
